import { api } from '../config'

export const ADMIN_URL = {
  create_admin: `${api.withAPI}/admin/`,
  get_admins: `${api.withAPI}/admin`,
  getAdminById: (id: string) => `${api.withAPI}/admin/${id}`,
  updateAdmin: (id: string) => `${api.withAPI}/admin/${id}`,
  deleteAdmin: (id: string) => `${api.withAPI}/admin/${id}`,
}
